<template>
</template>

<script>
  export default {
    name: 'home',
    data: function () {
      return {
        results: []
      }
    },
    mounted () {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Home.vue